import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccountPackageService } from 'src/app/service/account-package.service';

@Component({
  selector: 'app-service-package-list-template',
  templateUrl: './service-package-list-template.component.html',
  styleUrls: ['./service-package-list-template.component.scss']
})
export class ServicePackageListTemplateComponent implements OnInit {

  @Input()
  servicePackageList: Array<any>;

  selectedPackage: any;
  isViewPackageDetail: boolean = false;

  @Output() selectedServicePackageEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedServicePackageCloseEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private accountServicePackage: AccountPackageService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.servicePackageList = this.accountServicePackage.setPackageRatePlan(this.servicePackageList);
  }

  packageSelected(pkg) {
    console.log("selected package::", pkg);
    this.selectedPackage = JSON.parse(JSON.stringify(pkg));
    this.isViewPackageDetail = true;
    var payload = {
      "key": "SERVICE_PACKAGE",
      "navText": pkg.name
    }
    this.selectedServicePackageEmitter.emit(payload);
  }

  closePackageDetailClicked(event) {
    this.isViewPackageDetail = false;
    this.selectedServicePackageCloseEmitter.emit(true);
  }

}
